<template>
  <section
    class="py-10 text-white relative overflow-hidden"
    style="background: linear-gradient(to right, #4f46e5, #9333ea)"
  >
    <div class="absolute inset-0 overflow-hidden">
      <div
        class="absolute -top-1/2 -left-1/4 w-96 h-96 bg-white/5 rounded-full blur-3xl"
      ></div>
      <div
        class="absolute -bottom-1/2 -right-1/4 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl"
      ></div>
    </div>

    <div class="container mx-auto px-4 text-center relative z-10">
      <div class="max-w-4xl mx-auto mb-6">
        <h2 class="text-4xl md:text-5xl font-bold mb-6 leading-tight">
          Hemen Şimdi Gigcep'i İndirin
        </h2>
        <p class="text-xl md:text-2xl mb-12 text-indigo-100">
          Boş zamanlarınızı değerlendirin ve hediyeler kazanmaya başlayın!
        </p>
      </div>

      <div
        class="flex flex-row items-center justify-center gap-8 mb-6"
        style="margin: 36px 0"
      >
        <div>
          <NuxtImg
            src="/img/download/google-play.png"
            width="200"
            height="60"
            class="cursor-pointer rounded-lg"
            alt="Google Play Store"
            @click="openMobilAppUrl"
          />
        </div>
        <div>
          <NuxtImg
            src="/img/download/app-store.webp"
            width="200"
            height="60"
            class="cursor-pointer rounded-lg"
            alt="Apple App Store"
            @click="openMobilAppWebUrl"
          />
        </div>
      </div>

      <div
        class="mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto"
      >
        <div
          class="transform hover:scale-105 transition-all duration-300"
          data-aos="fade-up"
          data-aos-delay="0"
        >
          <div class="relative group">
            <div
              class="absolute inset-0 bg-gradient-to-r from-indigo-400/20 to-purple-400/20 rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-300"
            ></div>
            <div
              class="relative bg-white/10 rounded-2xl p-6 backdrop-blur-sm border border-white/20 group-hover:border-white/30 transition-all duration-300"
            >
              <div class="text-3xl lg:text-4xl font-bold mb-2">460.000+</div>
              <p class="text-base text-indigo-100">Kayıtlı Kullanıcı</p>
            </div>
          </div>
        </div>

        <div
          class="transform hover:scale-105 transition-all duration-300"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <div class="relative group">
            <div
              class="absolute inset-0 bg-gradient-to-r from-purple-400/20 to-pink-400/20 rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-300"
            ></div>
            <div
              class="relative bg-white/10 rounded-2xl p-6 backdrop-blur-sm border border-white/20 group-hover:border-white/30 transition-all duration-300"
            >
              <div class="text-3xl lg:text-4xl font-bold mb-2">2.000.000+</div>
              <p class="text-base text-indigo-100">Oluşturulan Gig</p>
            </div>
          </div>
        </div>

        <div
          class="transform hover:scale-105 transition-all duration-300"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <div class="relative group">
            <div
              class="absolute inset-0 bg-gradient-to-r from-pink-400/20 to-indigo-400/20 rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-300"
            ></div>
            <div
              class="relative bg-white/10 rounded-2xl p-6 backdrop-blur-sm border border-white/20 group-hover:border-white/30 transition-all duration-300"
            >
              <div class="text-3xl lg:text-4xl font-bold mb-2">45.000.000+</div>
              <p class="text-base text-indigo-100">Toplam Gig Katılımı</p>
            </div>
          </div>
        </div>

        <div
          class="transform hover:scale-105 transition-all duration-300"
          data-aos="fade-up"
          data-aos-delay="300"
        >
          <div class="relative group">
            <div
              class="absolute inset-0 bg-gradient-to-r from-indigo-400/20 to-purple-400/20 rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-300"
            ></div>
            <div
              class="relative bg-white/10 rounded-2xl p-6 backdrop-blur-sm border border-white/20 group-hover:border-white/30 transition-all duration-300"
            >
              <div class="flex items-center justify-center mb-3">
                <Image size="{24}" class="text-indigo-200 mr-2" />
                <div class="text-3xl lg:text-4xl font-bold">100.000.000+</div>
              </div>
              <p class="text-base text-indigo-100">Kanıt Görseli</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
function openMobilAppUrl() {
  window.open(
    "https://play.google.com/store/apps/details?id=com.gigcep.app",
    "_blank",
  )
}

function openMobilAppWebUrl() {
  window.open("https://m.gigcep.com/", "_blank")
}
</script>
